import React from 'react'
import { StyledExternalLink, StyledExternalPageLink } from './Link.styles'

type ExternalLinkProps = {
  text: string | JSX.Element
  href: string
  openInNewTab: boolean
  underline?: boolean
}

export const ExternalLink = ({
  text,
  href,
  openInNewTab,
  underline,
}: ExternalLinkProps): JSX.Element => (
  <StyledExternalLink
    href={href}
    rel={openInNewTab ? 'noreferrer' : undefined}
    target={openInNewTab ? '_blank' : undefined}
    $underline={underline}
  >
    {text}
  </StyledExternalLink>
)

ExternalLink.defaultProps = {
  openInNewTab: true,
}

export const LearnMoreLink = ({
  href,
  onClick,
  darkBg,
}: {
  href: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  darkBg?: boolean
}): JSX.Element => (
  <StyledExternalPageLink href={href} onClick={onClick} $darkBg={darkBg}>
    Learn more
  </StyledExternalPageLink>
)
